export enum CropMethod {
  SEEDING_IN_GROUND = "SEEDING_IN_GROUND",
  SEEDING_INHOUSE = "SEEDING_INHOUSE",
  SEEDING_ON_HOT_BED = "SEEDING_ON_HOT_BED",
  PLANT = "PLANT",
  EXISTING = "EXISTING",
}

export const SEEDING_METHODS: CropMethod[] = [
  CropMethod.SEEDING_IN_GROUND,
  CropMethod.SEEDING_INHOUSE,
  CropMethod.SEEDING_ON_HOT_BED,
];
